import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'welcome-view',
    component: require('@/components/WelcomeView').default
  },
  {
    path: '/pastquestions/add',
    name: 'pastquestions_add',
    component: require('@/pages/pastquestions/new').default
  },
  {
    path: '/pastquestions/update',
    name: 'pastquestions_update',
    component: require('@/pages/pastquestions/all').default
  },
  {
    path: '/pastquestions/update/:qid',
    name: 'pastquestions_update_ID',
    component: require('@/pages/pastquestions/update').default
  },
  {
    path: '/docs/all',
    name: 'docs_all',
    component: require('@/pages/docs/all').default
  },
  {
    path: '/docs/update/:id',
    name: 'docs_update',
    component: require('@/pages/docs/createOrUpdate').default
  },
  {
    path: '/docs/new',
    name: 'docs_new',
    component: require('@/pages/docs/createOrUpdate').default
  },
  {
    path: '/explanation',
    name: 'exp_qs',
    component: require('@/pages/explanation/questions').default
  },
  {
    path: '/explanation/:id',
    name: 'exp_update_new',
    component: require('@/pages/explanation/update').default
  },
  {
    path: '/tests/questions',
    name: 'test-qs-view',
    component: require('@/pages/test-questions/list').default
  },
  {
    path: '/tests/questions/:id',
    name: 'test-qs-id-view',
    component: require('@/pages/test-questions/createOrUpdate').default
  },
  {
    path: '/practice/questions',
    name: 'practice-qs-view',
    component: require('@/pages/practice-questions/list').default
  },
  {
    path: '/practice/questions/:id',
    name: 'practice-qs-id-view',
    component: require('@/pages/practice-questions/createOrUpdate').default
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
